/*
 * Copyright (c) Kalaora 2022.
 * Author: fharold
 *
 * hilo-oauth-manager
 * ClientAdapter.tsx
 */

import React from "react";
import ListAdapter, {AdapterListener} from "../../tools/list/ListAdapter";
import Video from "../../models/Video";
import {APIPagination} from "../../tools/pagination/APIPagination";
import Translation from "../../services/translation/Translation";
import {Column} from "../../tools/list/Column";
import VideoDataProvider from "../../provider/VideoDataProvider";

export interface VideoAdapterListener extends AdapterListener<Video> {
}

export default class VideoAdapter extends ListAdapter<Video, VideoAdapterListener, APIPagination> {
    private _t: Translation;

    /**
     * constructor
     * @param videosProvider
     * @param listener
     * @param t
     */
    constructor(t: Translation, videosProvider: VideoDataProvider, listener?: VideoAdapterListener) {
        super();

        this._t = t;
        this.addColumn(new Column(t.id, "id", this._id));
        this.addColumn(new Column(t.title, "title", this._title));
        this.addColumn(new Column(t.subtitle, "subtitle", this._subtitle));
        this.addColumn(new Column(t.description, "description", this._description));
        this.addColumn(new Column(t.duration, "lengthS", this._duration));
        this.addColumn(new Column(t.published, "published", this._published));

        this.init(t.videoListEmpty,
            videosProvider,
            [],
            listener);
    }

    /**
     * _id
     * @returns {any}
     * @private
     * @param video
     */
    private _id = (video: Video): JSX.Element => {
        return <p className={"blue-hover"}>
            {video.id}
        </p>
    };

    /**
     * _title
     * @returns {any}
     * @private
     * @param video
     */
    private _title = (video: Video): JSX.Element => {
        return <p className={"blue-hover"}>
            {video.title}
        </p>
    };

    /**
     * _subtitle
     * @returns {any}
     * @private
     * @param video
     */
    private _subtitle = (video: Video): JSX.Element => {
        return <p className={"blue-hover"}>
            {video.subtitle}
        </p>
    };

    /**
     * _description
     * @returns {any}
     * @private
     * @param video
     */
    private _description = (video: Video): JSX.Element => {
        return <p className={"blue-hover"}>
            {video.description}
        </p>
    };

    /**
     * _duration
     * @returns {any}
     * @private
     * @param video
     */
    private _duration = (video: Video): JSX.Element => {
        return <p className={"blue-hover"}>
            {video.lengthS}
        </p>
    };

    /**
     * _published
     * @returns {any}
     * @private
     * @param video
     */
    private _published = (video: Video): JSX.Element => {
        return <input readOnly type="checkbox" checked={video.published}/>;
    }
}